// ----------------------------------------------------------------------------
// Section: Country Modal
// ----------------------------------------------------------------------------
//
// Country Modal Section
// - Based on the modal pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';

// Styles
import './_country-modal.scss';

/**
 * Country Modal Snippet Script
 * ------------------------------------------------------------------------------
 * A file that manage the country popup switcher when the user first comes to the website.
 * There will be no popup for returning users.
 */

var inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// Country Switch Popup
var doLocale = function() {

    var countryMap = {
        'myvega.ca':                     'CA',
        'myvega-ca.myshopify.com':       'CA',
        'myvega1.myshopify.com':         'US',
        'myvega.com':                    'US'
    };

    var hostCountry = countryMap[document.domain];

    // Default to US
    if (hostCountry === undefined) {
       // hostCountry = 'CA';
    }else {
        // Set CSS class on body
        $('body').addClass('country--'+hostCountry.toLowerCase());
    }



    // Don't show the modal if If we are inside the customizer.
    if (inIframe()) { return; }

    /**
     * Return Visitor!
     */
    if (localStorage.getItem('userCountry') !== null) {

        // if (localStorage.getItem('userCountry') != hostCountry) {

        //     $('#country-modal').addClass('js--isOpen');
        // }
    }

    /**
    * Show the modal if GeoIP2 fails to load or is blocked for security
    */
    else if (typeof geoip2 === 'undefined') {
        $('#modal_country-modal').addClass('modal--open');
    }

    /**
     * Newbie user!
     */
    else {
        // GeoIP fetched successfully
        var geoSuccess = function(location) {
            var geoCountryCode = location.country.iso_code;

            // assign country to localStorage.
            localStorage.setItem('geoCountry', geoCountryCode);

            // CHECK! Does geo country match host country?
            if (geoCountryCode !== hostCountry) {

                $('#modal_country-modal').addClass('modal--open');
            }
        };
        // GeoIP Failed, show popup always
        var geoError = function(err) {

            // Show modal if we cannot detect country.
            $('#modal_country-modal').addClass('modal--open');
            // console.log(err);
        };

        // Get location from geoip database
        geoip2.country(geoSuccess, geoError);
    }


    $('#modal_country-modal .button, #modal_country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();

        var linkCountry = $(this).attr('data-country');
        localStorage.setItem('userCountry', linkCountry);

        if (linkCountry == hostCountry) {
            $('#modal_country-modal').removeClass('modal--open');
            $('body').removeClass('noscroll');
        } else {
            window.location = $(this).attr('href');
        }
    });

    $('#modal_country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();
    });
};

doLocale();
